import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Tooltip from 'components/Shared/Tooltip/Index'
import isEmpty from 'lodash/isEmpty'

import { useFetchSessionUserQuery } from 'api/sessionUser'

import { useCheckFeature } from 'utils/hooks'

import colors from 'components/utils/colors'
import DynamicTextArea from 'components/Shared/DynamicTextArea/Index'
import Button from 'components/Shared/Button/Index'
import RichTextEditor from 'components/Shared/RichTextEditor/Index'

const StyledForm = styled.div`
  background: ${colors.secondary95};
  padding: 8px;
  margin-bottom: 20px;
`

const StyledDynamicTextArea = styled(DynamicTextArea)`
  textarea {
    min-height: 80px;
    max-height: 400px;
  }
`

const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  gap: 8px;
`

const CommentForm = ({ value, onChange, onClose, hasRichText }) => {
  // Polling to avoid session ending
  useFetchSessionUserQuery({}, { pollingInterval: 60000 * 10 })

  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState(value)
  const IS_RELAY_3134_RICHTEXT_EDITOR = useCheckFeature('RELAY_3134_RICHTEXT_EDITOR')

  const onSubmit = () => {
    onChange(inputValue)
  }

  const updateInputValue = (event) => {
    setInputValue(event.target.value)
  }

  const onChange_ = (value) => {
    setInputValue(value)
  }

  const validate = () => {
    const errors = {}

    if (!inputValue.trim()) {
      errors.body = t('ticketPage.commentsValidateBody')
    }

    return errors
  }

  const errors = validate()
  const isFormValid = isEmpty(errors)
  const validationTips = Object.values(errors).join('\n')

  return (
    <StyledForm data-test='comment-form'>
      {IS_RELAY_3134_RICHTEXT_EDITOR && (
        // <>, </> may be removed with IS_RELAY_3134_RICHTEXT_EDITOR removal
        <>
          {hasRichText
            ? (
              <RichTextEditor
                autoFocus
                value={inputValue}
                onChange={onChange_}
                placeholder={t('common.typeHere')}
                minRows={4}
              />
              )
            : (
              <StyledDynamicTextArea
                autoFocus
                small
                minRows={4}
                value={inputValue}
                onChange={updateInputValue}
                placeholder={t('common.typeHere')}
              />
              )
          }
        </>
      )}

      {!IS_RELAY_3134_RICHTEXT_EDITOR && (
        <StyledDynamicTextArea
          autoFocus
          small
          minRows={4}
          value={inputValue}
          onChange={updateInputValue}
          placeholder={t('common.typeHere')}
        />
      )}

      <Tooltip id='comment-form-tooltip' />

      <ButtonsRow>
        <Button
          disabled={!isFormValid}
          onClick={onSubmit}
          data-tooltip-content={validationTips || undefined}
          data-tooltip-id='comment-form-tooltip'
        >
          {t('common.send')}
        </Button>

        <Button
          onClick={onClose}
          secondary
        >
          {t('common.cancel')}
        </Button>
      </ButtonsRow>
    </StyledForm>
  )
}

CommentForm.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  hasRichText: PropTypes.bool,
}

export default CommentForm
